import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f9dae82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-wall load-error" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-container" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "oh no..."),
  /*#__PURE__*/_createElementVNode("h3", null, "We have had an error"),
  /*#__PURE__*/_createElementVNode("h4", null, "Error 404"),
  /*#__PURE__*/_createElementVNode("p", null, "Sorry...please check back (click refresh) in just a moment.")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}